// extracted by mini-css-extract-plugin
module.exports = {"labelContainer":"jobtitlecard_labelContainer__m0gJL","valueText":"jobtitlecard_valueText__UPMfd","cardStyle":"jobtitlecard_cardStyle__2Jz3-"};